<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <title-text>Profile.</title-text>
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" md="3">
            <div class="d-flex justify-center flex-column align-center">
              <v-img
                cover
                width="200px"
                height="200px"
                class="rounded-circle"
                :src="form.avatar"
              >
                <div class="fill-height bottom-gradient"></div>
                <template v-slot:placeholder>
                  <v-avatar color="secondary" size="100%">
                    <span
                      v-if="userObj.firstname && userObj.lastname"
                      class="white--text text-h3 font-weight-bold"
                      >{{ userObj.firstname[0] }}
                      {{ userObj.lastname[0] }}</span
                    >
                  </v-avatar>
                </template>
              </v-img>
              <v-btn
                @click="onButtonClick"
                class="py-5 mt-5 text-none"
                color="primary"
                dark
                depressed
                >Edit Picture</v-btn
              >
              <input
                ref="uploader"
                class="d-none"
                type="file"
                accept="image/*"
                @change="onFileChanged"
              />
              <v-btn
                v-if="!isEditing"
                @click="isEditing = true"
                class="py-5 mt-5 text-none"
                color="secondary"
                dark
                depressed
                >Edit Profile</v-btn
              >
            </div>
            <!-- </v-avatar> -->
          </v-col>
          <v-col cols="12" md="9">
            <v-row>
              <v-col cols="12" md="6">
                <div class="mb-2">First Name*</div>
                <v-text-field
                :loading="isLoading"
                  v-model="form.firstName"
                  placeholder="Enter first name"
                  outlined
                  :readonly="!isEditing"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <div class="mb-2">Middle Name</div>
                <v-text-field
                :loading="isLoading"
                  v-model="form.middleName"
                  placeholder="Enter middle name"
                  outlined
                  :readonly="!isEditing"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <div class="mb-2">Last Name*</div>
                <v-text-field
                :loading="isLoading"
                  v-model="form.lastName"
                  placeholder="Enter last name"
                  outlined
                  :readonly="!isEditing"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <div class="mb-2">Email Address*</div>
                <v-text-field
                :loading="isLoading"
                  v-model="form.email"
                  placeholder="Enter email Address"
                  outlined
                  :readonly="!isEditing"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <div class="mb-2">Phone Number*</div>
                <v-text-field
                :loading="isLoading"
                  v-model="form.phoneNumber"
                  placeholder="Enter phone number"
                  outlined
                  :readonly="!isEditing"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <div class="mb-2">Date Of Birth</div>

                <v-menu
                  :disabled="!isEditing"
                  ref="menu"
                  v-model="dobMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                    :loading="isLoading"
                      outlined
                      v-model="form.dateOfBirth"
                      placeholder="Date of Birth"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    ref="picker"
                    v-model="form.dateOfBirth"
                    :max="new Date().toISOString().substr(0, 10)"
                    min="1950-01-01"
                    @change="save"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <!-- <v-col cols="12" md="6">
                <div class="mb-2">Country*</div>

                <v-select
                  v-model="form.country"
                  :readonly="!isEditing"
                  :items="countryList"
                  item-text="name"
                  item-value="code"
                  label="Select Country"
                  outlined
                />
              </v-col>
              <v-col cols="12" md="6">
                <div class="mb-2">Gender</div>

                <v-select
                  v-model="form.gender"
                  :readonly="!isEditing"
                  :items="['Male', 'Female', 'Prefer not to say']"
                  item-text="name"
                  item-value="code"
                  label="Select Gender"
                  outlined
                />
              </v-col>
              <v-col cols="12" md="6">
                <div class="mb-2">Marital Status</div>

                <v-select
                  v-model="form.maritalStatus"
                  :readonly="!isEditing"
                  :items="['Single', 'Married', 'Divorced', 'Widowed']"
                  item-text="name"
                  item-value="code"
                  label="Select Marital Status"
                  outlined
                />
              </v-col>
              <v-col cols="12" md="6">
                <div class="mb-2">State</div>
                <v-text-field
                :loading="isLoading"
                  v-model="form.state"
                  placeholder="Enter State of Residence"
                  outlined
                  :readonly="!isEditing"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <div class="mb-2">City</div>
                <v-text-field
                :loading="isLoading"
                  v-model="form.city"
                  placeholder="Enter City"
                  outlined
                  :readonly="!isEditing"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <div class="mb-2">Zip Code</div>
                <v-text-field
                :loading="isLoading"
                  v-model="form.zipCode"
                  placeholder="Enter Zip Code"
                  outlined
                  :readonly="!isEditing"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <div class="mb-2">Street Address</div>
                <v-text-field
                :loading="isLoading"
                  v-model="form.address"
                  placeholder="Enter Address"
                  outlined
                  :readonly="!isEditing"
                ></v-text-field>
              </v-col> -->
            </v-row>
            <v-row>
              <v-col cols="12" class="pa-0 ma-0">
                <v-subheader>NEXT OF KIN</v-subheader>
              </v-col>
              <v-col cols="12" md="6">
                <div class="mb-2">Full Name*</div>
                <v-text-field
                :loading="isLoading"
                  v-model="form.nextOfKin"
                  placeholder="Enter Full Name"
                  outlined
                  :readonly="!isEditing"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <div class="mb-2">Email*</div>
                <v-text-field
                :loading="isLoading"
                  v-model="form.nextOfKinEmail"
                  placeholder="Enter Email"
                  outlined
                  :readonly="!isEditing"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <div class="mb-2">Phone Number*</div>
                <v-text-field
                :loading="isLoading"
                  v-model="form.nextOfKinPhoneNumber"
                  placeholder="Enter Phone Number"
                  outlined
                  :readonly="!isEditing"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-btn
              v-if="isEditing"
              :loading="isSending"
              :disabled="!rulesSatisfied"
              @click="handleEdit"
              block
              depressed
              color="primary"
              class="py-7 mt-10 text-none"
              >Save</v-btn
            >
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TitleText from "@/components/dashboard/DbTitleText.vue";
import countryList from "@/utils/countries.js";
import { mapActions, mapState } from "vuex";
import { UserService } from "@/services/index.js";
import * as S3 from "aws-sdk/clients/s3";

export default {
  components: {
    TitleText,
  },
  data() {
    return {
      countryList,
      isEditing: false,
      isLoading: false,
      isSending: false,
      dobMenu: null,
      selectedFile: null,
      form: {
        firstName: "",
        middleName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        password: "",
        referralCode: "",
        dateOfBirth: null,
        country: "",
        gender: "",
        avatar: "",
        maritalStatus: "",
        state: "",
        city: "",
        address: "",
        zipCode: "",
        nextOfKin: "",
        nextOfKinEmail: "",
        nextOfKinPhoneNumber: "",
      },
    };
  },
  computed: {
    ...mapState(["userObj"]),
    rulesSatisfied() {
      return (
        this.form.firstName &&
        this.form.lastName &&
        this.form.email &&
        this.form.phoneNumber.length > 10
      );
    },
  },
  methods: {
    ...mapActions("auth", ["getUserInfo"]),
    async handleEdit() {
      try {
        this.isSending = true;
        let body = {
          firstname: this.form.firstName,
          middlename: this.form.middleName,
          lastname: this.form.lastName,
          email: this.form.email,
          phonenumber: this.form.phoneNumber,
          dob: this.form.dateOfBirth,
          nextofkin: this.form.nextOfKin,
          nextofkinemail: this.form.nextOfKinEmail,
          nextofkinphonenumber: this.form.nextOfKinPhoneNumber,
          // country: this.form.country,
          // address_street: this.form.address,
          // address_city: this.form.city,
          // zip_code: this.form.zipCode,
          // marital_status: this.form.maritalStatus,
          // gender: this.form.gender,
          photourl: this.form.avatar,
        };
        // await UserService.updateProfile(this.profile);
        let result = await UserService.updateProfile(body);
        // console.log(result);
        this.$store.commit("openSnackbar", result.message);
        this.isEditing = false;
        this.isSending = false;

        this.loadUser();
      } catch (error) {
        this.$store.commit("openSnackbar", error.message);
        this.isEditing = false;
        this.isSending = false;
        // throw error;
      }
    },
    save(date) {
      this.$refs.menu.save(date);
    },
    onButtonClick() {
      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      this.selectedFile = e.target.files[0];

      if (this.selectedFile) {
        if (this.selectedFile.size > 4097152) {
          this.$store.commit("openSnackbar", "File is too big!");

          this.selectedFile = "";
        }
        this.changePicture();
      } else {
        this.$store.commit("openSnackbar", "Please select an image");
      }
      // this.form.avatar = URL.createObjectURL(this.selectedFile);

      // this.uploadFile(this.selectedFile, "pictures");
      // do something
    },
    async changePicture() {
      try {
      this.form.avatar = URL.createObjectURL(this.selectedFile);

        this.isSending = true;

        const { message} = await UserService.changeProfilePicture(
          this.selectedFile
        );

        this.$store.commit("openSnackbar", message);

        this.isSending = false;

        this.loadUser();
      } catch (error) {
        this.isSending = false;

        // throw error;
      }
    },
    async loadUser() {
      this.isLoading = true;
      try {
        // console.log("getting profile...");
        await this.getUserInfo();
        this.form.firstName = this.userObj.firstname;
        this.form.middleName = this.userObj.middlename;
        this.form.lastName = this.userObj.lastname;
        this.form.email = this.userObj.email;
        this.form.phoneNumber = this.userObj.phonenumber;
        this.form.dateOfBirth = this.userObj.dob;
        this.form.nextOfKin = this.userObj.nextofkin;
          this.form.nextOfKinEmail = this.userObj.nextofkinemail;
          this.form.nextOfKinPhoneNumber = this.userObj.nextofkinphonenumber;
          // this.form.country = this.userObj.country;
          // this.form.address = this.userObj.address_street;
          // this.form.city = this.userObj.address_city;
          // this.form.zipCode = this.userObj.zip_code;
          // this.form.maritalStatus = this.userObj.marital_status;
          // this.form.gender = this.userObj.gender;
          this.form.avatar = this.userObj.photourl;
      this.isLoading = false;

      } catch (error) {
      this.isLoading = false;

        // throw error;
        // if (
        //   error.name == "NetworkException" &&
        //   ![401, 403].includes(error.status)
        // )
        // this.loadingError = true;
      } 
    },
    uploadFile(file, FOLDER) {
      const u = new Promise((resolve) => {
        const contentType = file.type;
        const timestampprefix = new Date().getTime();
        const bucket = new S3({
          accessKeyId: process.env.VUE_APP_AWS_ID,
          secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
          region: "us-east-1",
        });
        const params = {
          Bucket: "homify-profile-pictures",
          Key: `${FOLDER}/${timestampprefix}${file.name}`,
          Body: file,
          ACL: "public-read",
          ContentType: contentType,
        };
        bucket
          .upload(params)
          .on("httpUploadProgress", (evt) => {
            // this.uploading = true;
            // this.value = Math.ceil((evt.loaded / evt.total) * 100);
          })
          .send((err, data) => {
            if (err) {
              resolve(false);
            }
            this.form.avatar = data.Location;
            this.handleEdit();
            resolve(data);
          });
      });

      return u;
    },
  },
  mounted() {
    this.loadUser();
  },
  watch: {
    dobMenu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
};
</script>
